import React from 'react';
import { Link } from 'react-router-dom';

function SideNavigationLink({ item, className = '' }) {
  const content = <>{item.prefix && <span>{item.prefix}</span>}{item.label}</>;
  return item.to
    ? <Link className={className} to={item.to}>{content}</Link>
    : <a className={className} href={item.href}>{content}</a>;
}

function SectionSideNavigation({ items = [], ariaLabel = 'Page navigation' }) {
  return (
    <aside className="section-side-navigation" aria-label={ariaLabel}>
      {items.map(item => <div className="section-side-navigation-group" key={item.to || item.href}>
        <SideNavigationLink item={item} className={item.children && item.children.length ? 'section-side-navigation-heading' : ''} />
        {(item.children || []).map(child => <SideNavigationLink item={child} className="section-side-navigation-child" key={child.to || child.href} />)}
      </div>)}
    </aside>
  );
}

export default SectionSideNavigation;
